import { getTimeDisplayPreference } from '@/utils/general'
import { dayjsWithTimezone } from '@/utils/intl/dateTimeFormatters'
import type { ICellEditorParams } from 'ag-grid-community'
import { TimePicker } from 'antd'
import dayjs from 'dayjs'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import type { Row } from '../driverGridColumnDefs'

export const TimeEditor = forwardRef(({ data, value, stopEditing, node }: ICellEditorParams<Row, string>, ref) => {
  const [newValue, setNewValue] = useState(value)
  const [visible, setVisible] = useState(true)

  const depotTZ = (
    node.field === 'am_shift.start_time' ? data?.am_shift?.timezone_data?.depot : data?.pm_shift?.timezone_data?.depot
  ) as string

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return newValue
    },
    isCancelBeforeStart() {
      return false
    },
    isCancelAfterEnd() {
      return false
    },
  }))
  useEffect(() => {
    if (!visible) {
      stopEditing()
    }
  }, [visible, stopEditing])

  return (
    <TimePicker
      use12Hours
      format='h:mm A'
      value={newValue ? dayjsWithTimezone(newValue, depotTZ) : null}
      onOk={(time) => setNewValue(time?.format() || null)}
      style={{ width: '100%' }}
      onOpenChange={setVisible}
      defaultOpen
      autoFocus
      allowClear={true}
    />
  )
})
